import { ConfigItem, WebsiteItem, ContractPriceItem, ShipmentMethod } from "@/types";
import { PreHangViewModel, PreHangOptionsViewModel, PreHangOption } from "@/types/preHang";
import usePreHangService from "../pre-hang-service";
import { Common } from "@/util/common";
import ShipmentMethodService from '@/services/shipment-method-service'

const preHangService = usePreHangService()

export class PreHangOptions {
    private door: ConfigItem | WebsiteItem | ContractPriceItem | null
    private options: PreHangViewModel | null | undefined
    private jambMaterialOptions: PreHangOption[] = []
    private loaded = false
    private shipmentOptions: PreHangOption[] = []

    public constructor(doorItem: ConfigItem | WebsiteItem | ContractPriceItem) {
        this.door = doorItem
        this.initOptions()
    }
    
    private async initOptions() {
        if(this.door) {
            this.options = await preHangService.getOptions(this.door)
            this.shipmentOptions = await this.getShipmentOptions()
            this.populateJambMaterialOptions()
            this.loaded = true
        }
    }

    public isLoaded() {
        return this.loaded
    }


    private populateJambMaterialOptions() {
        const item = this.door as any
        const hasSpecies = (item?.isContract && this.options?.contractOptions) || (!item?.isContract && this.options?.options)
        const hasPrimed = (item?.isContract && this.options?.primedContractOptions) || (!item?.isContract && this.options?.primedOptions)

        if (hasSpecies && this.options && this.options.speciesName !== 'Primed') {
            const jambMaterial = Common.getJambMaterial(this.options.speciesName)

            this.jambMaterialOptions.push({
                id: 1,
                preHangCategoryId: 28,
                name: jambMaterial,
                price: 0
            })
        }

        if (hasPrimed) {
            this.jambMaterialOptions.push({
                id: 2,
                preHangCategoryId: 28,
                name: 'Primed',
                price: 0
            })
        }
    }

    private async getShipmentOptions() {
        const shipOptions: PreHangOption[] = []
        const shipApi: ShipmentMethod[] = await ShipmentMethodService.getShipmentMethods()
        shipApi.forEach(option => {
            shipOptions.push({
                id: option.id,
                name: option.name,
                preHangCategoryId: 9999,
                price: 0
            })
        })

        return shipOptions
    }

    public getOptions(species: string, useContract = false) {
        let optionSet
        if(species.toLowerCase() == 'primed') {
            optionSet = (useContract) ? this.options?.primedContractOptions : this.options?.primedOptions
        } else {
            optionSet = (useContract) ? this.options?.contractOptions : this.options?.options
        }

        return this.flattenOptionsSet(optionSet as PreHangOptionsViewModel)
    }

    private flattenOptionsSet(optionSet: PreHangOptionsViewModel) {
        const flat = {
            ...optionSet.preHangOptions
        }

        for(const field in optionSet.doubleDoorOptions) {
            let key = field
            if(!field.includes('double')) {
                key = 'double' + field.charAt(0).toUpperCase() + field.slice(1)
            }
            flat[key] = optionSet.doubleDoorOptions[field]
        }

        for(const field in optionSet.machineOptions) {
            let key = field
            if(!field.includes('machine')) {
                key = 'machine' + field.charAt(0).toUpperCase() + field.slice(1)
            }
            flat[key] = optionSet.machineOptions[field]
        }

        flat.jambMaterial = this.jambMaterialOptions
        flat.shipmentMethod = this.shipmentOptions
        
        return flat
    }
}